/**
 * Điều hướng từ Quản lý tài khoản → màn lịch sử: truyền username qua router state
 * (và fallback localStorage).
 * @param {import("react-router-dom").Location} location
 */
export function consumeUsernameFilterForHistory(location) {
  const fromState = location.state?.usernameFilter;
  if (fromState != null && String(fromState).trim() !== "") {
    return String(fromState).trim();
  }
  try {
    const stored = localStorage.getItem("usernameFilter");
    if (stored != null && String(stored).trim() !== "") {
      localStorage.removeItem("usernameFilter");
      return String(stored).trim();
    }
  } catch (e) {
    // ignore
  }
  return "";
}

/** @param {string} username */
export function buildUsernameDataFilter(username) {
  const s = String(username ?? "").trim().toLowerCase();
  return s ? `username=${encodeURIComponent(s)}` : null;
}
